import { AbstractControl, ValidatorFn } from "@angular/forms";

export function startWithSpaceValidator(): ValidatorFn {
  return (control: AbstractControl) : { [key: string]: boolean } | null => {
    if (control.value && !control.value.match(/^[^\s].*$/)) {
      return { 'startWithSpace': true };
    }
    return null;
  };
}



// WEBPACK FOOTER //
// ./src/app/common/validators/startWithSpaceValidator.ts